// App.js
import React from 'react';
import {useState} from 'react';
import ProjectsPage from './ProjectsPage';
import MapPage from './LaunchPage';
import VideoManager from './videoPage';
import  TicketListPage from './TicketPage';
import LandingPage from './LandingPage';
import UserManagement from './UserManagement'

import { useEffect } from "react";


import { BrowserRouter, Routes, Route } from 'react-router-dom';

// export default function App() {
//   const project_page_state = useState(1);
//   const project_state = useState({});

//   return (
//     <BrowserRouter>
//       <Routes>
//         {/* You can add Project Details page later */}
//         <Route path='/' element={<LandingPage />} />
//         <Route path='/user-management' element={<ExternalRedirect />} />
//         <Route path='/projects' element={<ProjectsPage page_state={project_page_state} project_state={project_state} />} />
//         <Route path='/route-planner' element={<MapPage  project_state={project_state} />} />
//         <Route path='/route-video' element={<VideoManager />} />
//         <Route path='/survey-tickets' element={<TicketListPage />} />

//       </Routes>
//     </BrowserRouter>
//   );
// }


export default function App() {
  // Load initial state from localStorage (or fallback to defaults)
  const [project_page_state, setProjectPageState] = useState(() => {
    const saved = localStorage.getItem("project_page_state");
    return saved ? JSON.parse(saved) : 1;
  });

  const [project_state, setProjectState] = useState(() => {
    const saved = localStorage.getItem("project_state");
    return saved ? JSON.parse(saved) : {};
  });

  const [user_state, setUserState] = useState(() => {
    const saved = localStorage.getItem("user_state");
    return saved ? JSON.parse(saved) : {};
  });

  // Persist changes to localStorage whenever state updates
  useEffect(() => {
    localStorage.setItem("project_page_state", JSON.stringify(project_page_state));
  }, [project_page_state]);

  useEffect(() => {
    localStorage.setItem("project_state", JSON.stringify(project_state));
  }, [project_state]);

  useEffect(() => {
    localStorage.setItem("user_state", JSON.stringify(user_state));
  }, [user_state]);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage user_state = {[user_state, setUserState]} />} />
        <Route path="/user-management" element={<UserManagement />} />
        <Route path="/projects" element={ <ProjectsPage page_state={[project_page_state, setProjectPageState]} project_state={[project_state, setProjectState]}  /> } />
        <Route path="/route-planner" element={<MapPage project_state={[project_state, setProjectState]} />} />
        <Route path="/route-video" element={<VideoManager />} />
        <Route path="/survey-tickets" element={<TicketListPage />} />
      </Routes>
    </BrowserRouter>
  );
}

